export const GRAB_CURSOR = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="2" cy="2" r="2" fill="currentColor"/>
<circle cx="10" cy="2" r="2" fill="currentColor"/>
<circle cx="2" cy="10" r="2" fill="currentColor"/>
<circle cx="10" cy="10" r="2" fill="currentColor"/>
</svg>
`;

export const DRAG_CURSOR = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="12" height="11" viewBox="0 0 12 10" xmlns="http://www.w3.org/2000/svg">
<circle cx="2" cy="2" r="2" fill="#E3E3E3"/>
<circle cx="8" cy="2" r="2" fill="#E3E3E3"/>
<circle cx="2" cy="8" r="2" fill="#E3E3E3"/>
<circle cx="8" cy="8" r="2" fill="#E3E3E3"/>
</svg>
`;
export const DRAG_CURSOR_BLACK = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="2" cy="2" r="2" fill="#041519"/>
<circle cx="10" cy="2" r="2" fill="#041519"/>
<circle cx="2" cy="10" r="2" fill="#041519"/>
<circle cx="10" cy="10" r="2" fill="#041519"/>
</svg>
`
